import { useQuery } from "@tanstack/react-query";
import { fetchClientIntelligence, type ClientIntelSignal } from "../api/mock";

export function useClientIntelligence(clientId: string) {
  return useQuery<ClientIntelSignal[]>({
    queryKey: ["client", clientId, "intelligence"],
    queryFn: () => fetchClientIntelligence(clientId),
    staleTime: 60_000,
  });
}
